import {Routes} from '@angular/router';
import {appGuard} from './app.guard';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () => import('./pages/login/login.page').then(m => m.LoginPage)
  }, {
    path: 'home',
    loadChildren: () => import('./pages/home/home.routes').then(m => m.routes),
    canMatch: [appGuard]
  }, {
    path: 'preinscripciones/:bbdd/:user/:code',
    loadComponent: () => import('./pages/preinscripciones/preinscripciones.page').then( m => m.PreinscripcionesPage)
  },
  {path: '', redirectTo: 'home/agenda', pathMatch: 'full'},
  {path: '**', redirectTo: 'login', pathMatch: 'full'}
];
